import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setBanId, setBanError, selectDeviceById } from "../../../store/mine_craft/devicesSlice";
import { fetchDevice, blockDevice } from "../../../actions/mine_craft/devicesActions";
import { objToFormData } from "../../../helpers/FormHelper";

import { CheckCircleOutlined } from "@ant-design/icons";
import { Button as ButtonAnt } from "antd";
import DrawerRight from "../../../componets/DrawerRight";
import AlertBlock from "../../../componets/AlertBlock";
import FormBlock from "./_partials/_FormBlock";
import Meta from "./_partials/_Meta";
import RowInfo from "../../../componets/RowInfo";
import { formattedDate } from "../../../helpers/DateHelpers";
import { Button } from "../../../componets/Buttons";

const Block = () => {
  const dispatch = useAppDispatch();
  const id: any = useAppSelector(state => state.mineCraft.devices.banId);
  const error   = useAppSelector(state => state.mineCraft.devices.banError);
  const device    = useAppSelector(state => selectDeviceById(state, id));

  useEffect(() => {
    if (id) {
      dispatch(fetchDevice(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setBanError(null));
  }

  function onClose() {
    dispatch(setBanId(null));
  }

  function onClickUnBlock(type: 'ban' | 'mute') {
    handleSave({ type: type, period: 0, duration: 'days' }).catch(console.error);
  }

  function onFinish(data: any) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: any) {
    const formData = objToFormData(data);
    dispatch(blockDevice({ id, data: formData }));
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-device'>
        <h6 className="v-content-label">Block Device</h6>

        <div className='v-mb-20'>{<Meta device={device} about={true} />}</div>

        <div className='v-mb-20'>
          {
            device?.banned &&
              <RowInfo
                left={
                  <>
                    Banned Until: <u>{formattedDate(device?.banned_until).dateTime}</u>
                  </>
                }
                right={<Button onClick={() => onClickUnBlock('ban')} title='Remove Ban' icon={CheckCircleOutlined} />}
              />
          }
        </div>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <FormBlock params={{ period: 1, duration: 'days', type: 'ban' }} onFinish={onFinish} />

        <ButtonAnt className="v-btn v-btn-primary" onClick={onClose} style={{ width: '100%' }}>
          Close
        </ButtonAnt>
      </div>
    </DrawerRight>
  )
}

export default Block;
